export default __webpack_public_path__ + "static/media/Cabezal.a51835f2.jpg";